import { type CSSProperties, type PropsWithChildren, forwardRef } from 'react'
import { Link as ReactRouterLink } from 'react-router-dom'

export { Link }

type Props = PropsWithChildren<{
  to: string
  onClick?: () => void
  style?: CSSProperties
  target?: string
  rel?: string
}>

const Link = forwardRef<HTMLAnchorElement, Props>(
  ({ children, ...props }, ref) => {
    return (
      <ReactRouterLink ref={ref} {...props}>
        {children}
      </ReactRouterLink>
    )
  },
)

Link.displayName = 'Link'
